<div>
    <div class="row ">
      <div class="col">
        <h4 class="mb-0 font-header" style="font-weight: 700;">Calendar Schedule </h4>
      </div>
    </div>
    <div *ngIf="global.globalAgencyId==null || global.globalAgencyId==undefined ||global.globalAgencyId=='00000000-0000-0000-0000-000000000000'|| global.globalAgencyId=='' ">
      <div class="row mt-4 ">
        <div class="col ">
          <div widget class="card border-0 box-shadow">
            <div class="card-body  widget-body pt-2">
              <div class="text-center text-danger">
                <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to
                  view
                  details</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4"
      *ngIf="global.globalAgencyId!=null && global.globalAgencyId!='' && global.globalAgencyId!=undefined &&  global.globalAgencyId!='00000000-0000-0000-0000-000000000000'">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div #calenderFilter class="row">
          <div widget class="card border-0 box-shadow ms-3" style="width: 98%;">
            <div class="card-body  widget-body pb-0 pt-2">
              <div class="row mb-2">
                <div class="col-lg-12 col-md-12">
                  <div class="row">
                    <div class="col-lg-4">
                      <div class="row">
                        <label class="col-lg-12">Employee</label>
                        <div class="col-lg-12">
                          <ng-select [searchable]="true" [clearable]="true" [items]="EmployeeList"  bindLabel="Value" bindValue="Key" id="CSfilteremployee" [(ngModel)]="EmployeeId">
                          </ng-select>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2">
                      <div class="row">
                        <label class="col-lg-12">Calendar Date <sup class="super-script">&nbsp;*</sup></label>
                        <div class="col-lg-12">
                          <my-date-picker [options]="myDatePickerOptions" [disabled]="global.globalAgencyId==0"
                            [selDate]="calendarDate" (dateChanged)="onDateChanged($event)" placeholder="mm/dd/yyyy">
                          </my-date-picker>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2">
                      <div class="row">
                        <label class="col-lg-12">Time</label>
                        <div class="col-lg-12">
                          <input type="time" class="form-control" id="CSsetWorkHours" [(ngModel)]="timefrom"
                          (change)="isTimeChange=true;timeFromChange()" (keyup.enter)="setWorkHours()">
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-6 mt-4">
                        <button type="button" class="btn btn-sm" 
                            (click)="isEvents=true" >
                            Add Events
                        </button>
                    </div>
                    <div class="col-lg-2 ms-auto mt-4 ">
                      <button class="btn btn-sm  mt-1" id="CSapplyfilter1"
                        [disabled]="global.globalAgencyId==0||calendarDate==null||calendarDate==undefined||calendarDate==''"
                        (click)="ApplyFilter()">Apply</button>&nbsp;&nbsp;
                      <button class="btn  btn-sm   mt-1" id="CSclearfilter1"
                        [disabled]="global.globalAgencyId==0" (click)="EmployeeId='';ClearFilter();">Clear</button>
                    </div>
                  </div>
  
                </div>
              </div>
              <div class="control-section">
                <div class="drag-sample-wrapper">
                  <div class="schedule-container">
                    <ejs-schedule #scheduleObj cssClass='schedule-event-template' [allowResizing]='false' width="100%" [height]="schduleheight.calendarHeight"  [group]="group" [currentView]="currentView"
                      [selectedDate]="selectedDate" [startHour]="global.startTime" [endHour]="endHour"
                      [eventSettings]="global.eventSettings" [timeScale]="timeScale" [showHeaderBar]="false"
                      (popupOpen)='editDataPopup($event,editData);popupAlert=""' (actionBegin)="onActionBegin($event)"
                      (drag)="onItemDrag($event)" (dragStart)="onDragStart($event)" (dragStop)="onDragStop($event)">
                      <ng-template #eventSettingsTemplate let-data>
                        <div [style.background]="data.bgColor" [style.color]="data.color"
                         >
                          <div>{{ data.Name }}</div>
                          <div>Time: {{ data.startTime | date:'shortTime' }} - {{ data.endTime | date:'shortTime' }}</div>
                        </div>
    
                      </ng-template>
                      <e-resources>
                        <e-resource field='EmployeeID' title='Employee' name='Employees' [dataSource]='paginatedEmployees'
                          textField='Value' idField='Key'>
                        </e-resource>
                      </e-resources>
                      <ng-template #resourceHeaderTemplate let-data>
                        <div class="template-wrap">
                          <div class="specialist-category">
                            <div class="specialist-name">{{getConsultantName(data)}}</div>
                          </div>
                        </div>
                      </ng-template>
                      <e-views>
                        <e-view option='TimelineDay'></e-view>
                        <e-view option='Week'></e-view>
                        <e-view option='Month'></e-view>
                        <e-view option='TimelineMonth'></e-view>
                      </e-views>
                    </ejs-schedule>
                    <div class="row align-items-center mt-4">
                      <div class="col-lg-12 d-flex justify-content-between">
                        <div>
                          <button (click)="prevPage()" [disabled]="currentPage == 1 || stoppagination==true"
                            class="btn  btn-sm"><i class="fa fa-angle-double-left"
                              style="font-size:18px"></i></button>
                          <span class="mx-3"><b>Page {{ currentPage }} of {{ totalPages }}</b></span>
                          <button (click)="nextPage()" [disabled]="currentPage == totalPages ||stoppagination==true"
                            class="btn  btn-sm"><i class="fa fa-angle-double-right"
                              style="font-size:18px"></i></button>
                        </div>
                        <div>
                          <div>
                            <label class="me-1"><b>Items per page:</b></label>
                            <select [(ngModel)]="pageSize" (ngModelChange)="updatePagination('PagePerItem',$event)"
                              class="form-control" style="width: auto; display: inline;">
                              <option *ngFor="let size of [10, 15, 20, 50,100,250]" [value]="size">{{size}}</option>
                            </select>
                            <label class="ms-1"><b>of {{totalEmployees}}</b></label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                  </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <span id="openEditor" data-bs-toggle="modal" data-bs-target="#editorwindow"></span>
  <div class="modal fade" id="editorwindow" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="font-header modal-title ">
            Schedule Details</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="CSSdetailsclsicon1">
            <span aria-hidden="true"></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="alert alert-warning alert-dismissible fade show" *ngIf="saveErr!=''" role="alert">
            <p>{{saveErr}}</p>
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="saveErr=''"
              id="CSAutherrclsicon2">
              <span aria-hidden="true"></span>
            </button>
          </div>
          <form [formGroup]="FrequencyForm">
            <div class="row">
              <div class="col-lg-4">
                <label>Employee<sup class="super-script">&nbsp;*</sup></label>
                <ng-select formControlName="Employee" id="CSedropdown" [searchable]="true" [clearable]="true"
                  [(ngModel)]="scheduleEditList.EmployeeID" [items]="EmployeeList" bindLabel="Value" bindValue="Key">
                </ng-select>
              </div>
              <!-- <div class="col-lg-2">
                <label>Scheduled Date <sup class="super-script">&nbsp;*</sup></label>
                <my-date-picker [options]="myDatePickerOptions" formControlName="ScheduledDate" placeholder="mm/dd/yyyy"
                  [selDate]="scheduleEditList.startDate"
                  (inputFieldChanged)="newdates($event,'inputchage','startDate')"
                  (dateChanged)="newdates($event,'datechagned','startDate')">
                </my-date-picker>
              </div> -->
              <div class="col-lg-2">
                <label>Start Date <sup class="super-script">&nbsp;*</sup></label>
                <input class="form-control" formControlName="StartTime" id="CSStartTime"
                  [(ngModel)]="scheduleEditList.startTime" type="datetime-local" (ngModelChange)="StartDateChange()">
              </div>
              <div class="col-lg-2">
                <label>End Date <sup class="super-script">&nbsp;*</sup></label>
                <input class="form-control" formControlName="EndTime"  [(ngModel)]="scheduleEditList.endTime "
                  type="datetime-local" id="CSEndTime">
              </div>
            </div>
  
          </form>
        </div>
        <div class="modal-footer">
          
            
            <button class="btn btn-sm  me-2" id="CSupdateNonScheduleWithTime" style="float:right"
              [disabled]="scheduleEditList.EmployeeID== null || scheduleEditList.EmployeeID== 0|| scheduleEditList.EmployeeID== undefined || saveEditErr ||isClickButton"
              (click)="OutBoundCall()">Update
            </button>
            <button class="btn btn-sm  me-1" data-bs-dismiss="modal" id="CSclosecalendar"  style="float:right"
              (click)="saveAuthErr='' ;saveErr=''">Close</button>
        
        </div>
      </div>
    </div>
  </div>

  
<!-- call popup -->
<span id="opencallModel" data-bs-toggle="modal" data-bs-target="#modalCallPopup"></span>
<div class="modal fade" id="modalCallPopup" data-bs-backdrop="static">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span>Reminder</span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                Do you want reminder for this event?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal" (click)="updateCalendarScheduleEmployee('clickevent');" >Yes</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal" (click)="updatecalendarschedule.getConfirmation = false;updateCalendarScheduleEmployee('clickevent');" >No</button>
            </div>
        </div>
    </div>
</div>

<!-- no call -->
<span id="openNoCallModel" data-bs-toggle="modal" data-bs-target="#modalNoCallPopup"></span>
<div class="modal fade" id="modalNoCallPopup" data-bs-backdrop="static">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span>No Reminder</span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                Reminder will not be sent for this event due to {{msg}}.
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"(click)="updatecalendarschedule.getConfirmation = false;  updateCalendarScheduleEmployee('clickevent');">Ok</button>
            </div>
        </div>
    </div>
  </div>

  <app-events *ngIf="isEvents" [inputfromCalendar]="isEvents"  (emitfromEvents)="datafromEvents($event)"></app-events>
         

